export default __webpack_public_path__ + "static/media/gplaystore.85451e2d.svg";